import { Box, Container, Text } from '@chakra-ui/react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box as="footer" py={4} backgroundColor="gray.100">
      <Container maxW="container.xl">
        <Text textAlign="center" color="gray.600">
          © {currentYear} Irori Tourism. All rights reserved.
        </Text>
      </Container>
    </Box>
  );
};

export default Footer;